import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type ButtonVariantType, buttonVariantList } from '../../typings/buttonVariantType';
import { defaults } from '../defaults';

export const withButtonVariantProps = {
  /**
   * Wariant przycisku
   */
  variant: {
    type: String as PropType<ButtonVariantType>,
    default: defaults.button.variant
  }
};

/**
 * Zwraca klasę wariantu przycisku
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withButtonVariantProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useButtonVariantProps = (prefix: string, props: ExtractPropTypes<typeof withButtonVariantProps>) => {
  return computed(() => ({
    [`${prefix}--${props.variant}`]: props.variant !== undefined
  }));
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesButtonVariantArgs = {
  args: {
    variant: defaults.button.variant
  },

  argTypes: {
    variant: {
      options: buttonVariantList,
      control: { type: 'select' }
    }
  }
};
